const euro = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
})

export function formatEuro(value?: number): string {
  return euro.format(value || 0)
}

// Parses a number input value; empty input clears the amount
export function parseAmount(value: string): number | undefined {
  if (value === '') return undefined
  const parsed = Number(value)
  return Number.isNaN(parsed) ? undefined : Math.max(0, parsed)
}
